<style scoped>

/* Live Feed CSS */
pre.code-pre{
    background: #f3f3f3;
    max-height: 300px;
}

.meta {
    color: #777;
    font-size: .85em;
}

.meta-bit {
    color: #333;
    font-weight: bold;
}

>>>span.badge.nohover{
    font-size: 10px;
    text-align: center;
    min-height: 1.1rem;
}

span.badge.nohover.badge-light.badge-pill{
    background-color: #d1e3ff !important;
}

span.badge.nohover.yara-pill.badge-secondary.badge-pill{
    background-color: #7400c6 !important;
}

.table-hover tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.075);
}

div#lf-tip{
    border-bottom-color: #000 !important;
    border-bottom-style: solid;
    border-bottom-width: 4px;
    border-top-color: #000 !important;
    border-top-style: solid;
    border-top-width: 4px;
    color: #000;
    text-align: center;
    background-color: #fff !important;
    border-radius: 0.25rem;
}
#lf-info.fa.fa-info-circle:hover{
    cursor: pointer;
}
span.badge.nohover.autoit-pill.badge-secondary.badge-pill{
    background-color: #5c82ac;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.downloader-pill.badge-secondary.badge-pill{
    background-color: #28a745;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.malpedia-pill.badge-secondary.badge-pill{
    background-color: #ff6a23;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.malpedia-restricted-pill.badge-secondary.badge-pill{
    background-color: #de4900;
    /*background-color: #b14815;*/
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.deepmatch-pill.badge-secondary.badge-pill{
    background-color: #701fb9;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.children-pill.badge-secondary.badge-pill{
    background-color: #bfbfbf;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.nochildren-pill.badge-secondary.badge-pill{
    background-color: #f1d543;
    font-weight: normal;
    font-size: 10px;
}
>>>thead{
    line-height: 1;
    font-size: 0.9rem;
}
>>>tbody{
    line-height: 1;
    font-size: 0.9rem;
}
a#bt-scroll.btn.btn-secondary.btn-block{
    min-width: 1120px;
    background-color: #ffffff;
    border-color: #ffffff;
    color: #bcbec0;
}
a#bt-scroll.btn.btn-secondary.btn-block:hover{
    background-color: #fdfdff;
    box-shadow: 0 0 0 0rem rgba(108, 117, 125, 0.5);
}
a#bt-scroll.btn.btn-secondary.btn-block:focus{
    box-shadow: 0 0 0 0rem rgba(108, 117, 125, 0.5);
}
a#bt-scroll-dissable.btn.btn-secondary.btn-block{
    min-width: 1120px;
    background-color: #ffffff;
    border-color: #ffffff;
    color: #bcbec0;
}
a#bt-scroll-dissable.btn.btn-secondary.btn-block:hover{
    background-color: #ffffff;
    cursor: default;
    box-shadow: 0 0 0 0rem rgba(108, 117, 125, 0.5);
}
a#bt-scroll-dissable.btn.btn-secondary.btn-block:focus{
    box-shadow: 0 0 0 0rem rgba(108, 117, 125, 0.5);
}
.blinking{
    animation:blinkingText 2s infinite;
}

@keyframes blinkingText{
    0%{     color: rgba(188, 190, 192, 0.1);  }
    5%{     color: rgba(188, 190, 192, 0.2);  }
    10%{    color: rgba(188, 190, 192, 0.3);  }
    15%{    color: rgba(188, 190, 192, 0.4);  }
    20%{    color: rgba(188, 190, 192, 0.5);  }
    25%{     color: rgba(188, 190, 192, 0.6);  }
    30%{   color: rgba(188, 190, 192, 0.7);    }
    35%{   color: rgba(188, 190, 192, 0.8);    }
    40%{   color: rgba(188, 190, 192, 0.9);    }
    45%{   color: rgba(188, 190, 192, 1);    }
    50%{   color: rgba(188, 190, 192, 0.9);    }
    55%{   color: rgba(188, 190, 192, 0.8);    }
    60%{   color: rgba(188, 190, 192, 0.7);    }
    65%{   color: rgba(188, 190, 192, 0.6);    }
    70%{   color: rgba(188, 190, 192, 0.5);    }
    75%{   color: rgba(188, 190, 192, 0.4);    }
    80%{   color: rgba(188, 190, 192, 0.3);    }
    85%{   color: rgba(188, 190, 192, 0.2);    }
    90%{   color: rgba(188, 190, 192, 0.1);    }
    95%{   color: rgba(188, 190, 192, 0);    }
    100%{   color: rgba(188, 190, 192, 0);    }
}

h1#info-page{
    font-size:45px;
    font-weight:300;
    height:54px;
    line-height:54px;
}
</style>

<template>
<div class="container">
    <template v-if="!isMobile()">
        <div class="row">
            <div class="col-sm-6">
                <h1 id="info-page">
                    History
                    <template v-if="resultsLoading">
                        <small style="color:#b4bcc2;font-size:0.9rem;">
                            <b-spinner small label="Loading..."></b-spinner>
                        </small>
                    </template>
                </h1>
            </div>
        </div>
        <template v-if='Object.keys(historyResults).length'>
            <div class="row">
                <div class="col-sm-10">
                    <table class="table table-hover" style="max-width: 70rem;min-width: 70rem;">
                      <thead>
                        <tr>
                          <th scope="col">Submitted</th>
                          <th scope="col"></th>
                          <th scope="col">Sample</th>
                          <th scope="col">Children</th>
                          <th scope="col">Tags</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                        <tbody>
                            <tr class="meta" v-for="(sample, index) in historyResults" :key="index" >
                                <td style="line-height: 1.5;">
                                    {{ sample.created | moment("DD/MM/YYYY")  }}
                                    <br>
                                    {{ sample.created | moment("HH:mm:ss")  }}
                                </td>
                                <td>
                                    <template v-if="sample.private">
                                        <i id="privateOption" class="fa fa-eye-slash"></i>
                                        <b-tooltip target="privateOption" triggers="hover">
                                            Private  
                                        </b-tooltip>
                                    </template>
                                </td>
                                <td><a class="txtlink"  target="_blank" :href="'/results/'+sample.id"><b class="txtlink">{{ sample.sha256 }}</b></a></td>
                                <td>
                                    <template if="sample.status === 'complete'">
                                        <template v-if="sample.children === 0 &&
                                                        !sample.downloader &&
                                                        !Object.keys(sample.malwareid).length &&
                                                        !Object.keys(sample.malwareid_restricted).length">
                                            <b-badge pill style="pointer-events:none" class="nohover nochildren-pill"><b>{{sample.children}}</b></b-badge>
                                        </template>
                                        <template v-else>
                                            <b-badge pill style="pointer-events:none" class="nohover children-pill"><b>{{sample.children}}</b></b-badge>
                                        </template>
                                    </template>
                                </td>
                                <td style="line-height: 1.5;">
                                    <template v-if="sample.autoit">
                                        <b-badge pill style="pointer-events:none" v-bind:key="sample.autoit.id" class="nohover autoit-pill"><b>AutoIt</b></b-badge>
                                    </template>
                                    <template v-if="sample.downloader">
                                        <b-badge pill style="pointer-events:none" v-bind:key="sample.downloader.id" class="nohover downloader-pill"><b>Network Dropper</b></b-badge>
                                    </template>
                                    <template v-for="malwareidHit in sample.malwareid">
                                        <template v-if="malwareidHit.type ==='malpedia'">
                                            <b-badge pill style="pointer-events:none" v-bind:key="malwareidHit.id" class="nohover malpedia-pill"><b>{{malwareidHit.match}}</b></b-badge>
                                        </template>
                                    </template>
                                    <template v-for="malwareidHit in sample.malwareid_restricted">
                                        <template v-if="malwareidHit.type ==='malpedia'">
                                            <b-badge pill style="pointer-events:none" v-bind:key="malwareidHit.id" class="nohover malpedia-restricted-pill"><b>{{malwareidHit.match}}</b></b-badge>
                                        </template>
                                    </template>
                                    <template v-for="deepMatchHit in sample.deepmatch">
                                        <b-badge pill style="pointer-events:none" v-bind:key="deepMatchHit.id" class="nohover deepmatch-pill"><b>{{deepMatchHit.label}}</b></b-badge>
                                    </template>
                              </td>
                              <td>
                                <span v-if="sample.status === 'fail'">
                                    <b-badge type="pill" variant="danger" style="max-width: 10rem;min-width:6rem;pointer-events:none" class="nohover"><b>{{ sample.status }}</b></b-badge>
                                </span>
                                <span v-else-if="sample.status === 'complete'">
                                    <b-badge type="pill" variant="success" style="max-width: 10rem;min-width:6rem;pointer-events:none"  class="nohover"><b>{{ sample.status }}</b></b-badge>
                                </span>
                                <span v-else-if="sample.status === 'timeout'">
                                    <b-badge type="pill" variant="warning" style="max-width: 10rem;min-width:6rem;pointer-events:none"  class="nohover"><b>{{ sample.status }}</b></b-badge>
                                </span>
                                <span v-else>
                                    <b-badge type="pill" style="max-width: 10rem;min-width:6rem;pointer-events:none"  class="pill pill-secondary pill-sm nohover"><b>{{ sample.status }}</b></b-badge>
                                </span>
                              </td>
                            </tr>
                        </tbody>
                    </table>
                    <template v-if="resultsMore">
                        <template v-if="!resultsLoading">
                            <b-btn block href="#" id="bt-scroll" v-on:click="getHistory()" >
                                <span class="blinking">
                                    <h5 align="center" slot="header">
                                        <i class="fa fa-angle-double-down"></i>
                                    </h5>
                                </span>
                            </b-btn>
                        </template>
                        <template v-else>
                            <b-btn block href="#" id="bt-scroll-dissable" >
                                <h5 align="center" slot="header">
                                    <pulse-loader :loading="resultsLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                </h5>
                            </b-btn>
                        </template>
                    </template>
                </div>
            </div>
        </template>
    </template>
    <!-- ######################### BUILD MOBILE VERSION ######################### -->
    <template v-else>
        <div class="row">
            <div class="col-sm-6">
                <h1 id="info-page">History</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-10">
                <table class="table table-hover" style="max-width: 21rem;min-width: 21rem;">
                  <thead>
                    <tr>
                      <th scope="col">Samples</th>
                    </tr>
                  </thead>
                  <tbody v-for="(sample, index) in historyResults" :key="index" >
                    <tr class="meta" style="line-height: 4;">
                        <a class="txtlink"  target="_blank" :href="'/results/'+sample.id"><b class="txtlink" style="font-size: 8px;">{{ sample.sha256 }}</b></a>
                    </tr>
                  </tbody>
                </table>
            </div>
        </div>
    </template>
</div>
</template>

<script>
import axios from 'axios';

export default {
    props: ['auth', 'authenticated'],
    data() {
        return {
            // For controlling the timer and status display
            historyResults: [],
            resultsCursor: null,
            resultsMore: true,
            resultsLoading: true,
            // my_timer: 0
        };
    },
    beforeCreate() {
        document.body.className = 'none';
    },
    metaInfo() {
        return {
            title: 'UnpacMe History',
            meta: [{ name: 'description', content: 'UnpacMe is an automated malware unpacking service. We provide malware analysis at Internet scale. Free for non-commercial use.' },
                { name: 'keywords', content: 'unpacking,unpacme,unpakme,unpackme,malware,malware analysis,analysis,automation,sandbox,oalabs,openanalysis,open analysis' }],
        };
    },
    methods: {
        isMobile() {
            if (navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            // ipad is a full browser
            // navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)) {
                console.log('is mobile');
                return true;
            }
            console.log('not mobile');
            return false;
        },
        getHistory() {
            const tempBearer = this.getAuthBearer();
            this.resultsLoading = true;
            let historyUrl = '';
            if (this.resultsMore) {
                if (this.resultsCursor === null) {
                    historyUrl = 'https://api.unpac.me/api/v1/private/history';
                } else {
                    historyUrl = `https://api.unpac.me/api/v1/private/history?cursor=${this.resultsCursor}`;
                }
                axios({
                    url: historyUrl,
                    headers: { Authorization: tempBearer },
                    method: 'GET',
                }).then((response) => {
                    this.historyResults.push(...response.data.results);
                    this.resultsCursor = response.data.cursor;
                    this.resultsLoading = false;
                })
                    .catch((error) => {
                        this.resultsLoading = false;
                        if (error.response.status === 404) {
                        // No more history just remove button
                            this.resultsMore = false;
                        } else {
                            console.error(error);
                        }
                    });
            }
        },
        clickGoTo(sample) {
            // window.location.href = "/results/"+sample.id;
            window.open(
                `/results/${sample.id}`,
                '_blank', // <- This is what makes it open in a new window.
            );
        },
        getAuthBearer() {
            this.accessToken = localStorage.getItem('access_token') || null;
            return `Bearer ${this.accessToken}`;
        },
    },
    created() {
        this.getHistory();
        // this.my_timer = setInterval(this.getFeed, 90000)
    },
    beforeDestroy() {
        // Clear the timer
        // clearInterval(this.my_timer)
    },
};
</script>




// WEBPACK FOOTER //
// src/components/History.vue